package com.eladfinish.bible.contest.screens.mikud.model

data class RemoteMikudMenuItem(
    val name: String,
    val info: String,
    val createdAtMillis: Long,
    val createdAtText: String,
    val mikudContent: RemoteMikudContent,
)
